import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AlertifyService } from '../../_service/alertify.service';
import { AuthService } from '../../_service/auth.service';
import { UserService } from '../../_service/user.service';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { LoginComponent } from 'src/app/login/login.component';

@Component({
  selector: 'app-user-updatepassword',
  templateUrl: './user-updatepassword.component.html',
  styleUrls: ['./user-updatepassword.component.css']
})

export class UserUpdatepasswordComponent implements OnInit {


  confirmPassword: any;
  password: any;
  model: any = {};
  hide = true;
  passwordForm: FormGroup;
  restrictedAccess: any = [];

 user = {
      userOutsideId: '',
      password: ''
    };

  passwordChanged: any = [];

 userOutsideId = this.passedData.user;

   constructor(private userService: UserService,
    private alertify: AlertifyService,
    public fb: FormBuilder,
    private router: Router,
    public authService: AuthService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public passedData: any) {

       this.passwordForm = fb.group({
        // pattern: 8 characters in length, lowercase, uppercase, numbers, special characters
      passwordFormControl : new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.minLength(6),
        Validators.maxLength(20),
      ]),
      confirmPasswordFormControl : new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.minLength(6),
        Validators.maxLength(20)
      ]),
     
   });
    }

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}



  ngOnInit() {
  }

  loginPrompt() {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px'
    });
  }

  updatePassword() {
      if (this.model.password === this.model.confirmPassword) {
        this.user.userOutsideId = this.userOutsideId;
        this.user.password = this.model.password;

        return this.userService.updateIdentityPassword(this.user).subscribe(
          (res: any) => {
            this.restrictedAccess = res.headers.get('restrictedaccess');
            if (this.restrictedAccess) {
              this.alertify.message(this.restrictedAccess);
            }
          this.passwordChanged = res.headers.get('changepassword');
          if (this.passwordChanged) {
          this.alertify.success(this.passwordChanged);
          this.dialog.closeAll();
          this.authService.logout();
          this.loginPrompt();
          this.alertify.message('Please login.');
          }
        }, error => {
          this.alertify.error(error);
        });
      } else {
        this.alertify.error('Passwords do not match');
      }
  }

}
